import { SORT_LABELS, type SortMode } from '../utils/sort';
import { ViewerToggle } from './ViewerToggle';

export interface SortOption {
  value: string;
  label: string;
}

interface Props {
  activeCount?: number;
  sortMode: string;
  onSortChange: (mode: string) => void;
  sortOptions?: SortOption[];
  viewer?: string;
  onViewerChange?: (v: string) => void;
}

const DEFAULT_MODES: SortMode[] = ['smart', 'due', 'priority', 'age'];
const DEFAULT_OPTIONS: SortOption[] = DEFAULT_MODES.map((m) => ({
  value: m,
  label: SORT_LABELS[m],
}));

export function ListFilters({
  activeCount,
  sortMode,
  onSortChange,
  sortOptions = DEFAULT_OPTIONS,
  viewer,
  onViewerChange,
}: Props) {
  return (
    <div className="list-filters">
      {activeCount !== undefined ? (
        <span className="list-filters-count">
          {activeCount}
          <span className="list-filters-count-suffix"> active</span>
        </span>
      ) : (
        <span className="list-filters-count" aria-hidden="true" />
      )}
      <div className="list-filters-right">
        {viewer !== undefined && onViewerChange && (
          <span className="list-filters-viewer">
            <ViewerToggle value={viewer} onChange={onViewerChange} />
          </span>
        )}
        <label className="sort-control">
          <span className="muted">Sort:</span>
          <select
            value={sortMode}
            onChange={(e) => onSortChange(e.target.value)}
            aria-label="Sort tasks"
          >
            {sortOptions.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
}
